var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGush({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.299,
    height: 41.796,
    viewBox: "0 0 29.299 41.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1064",
    "data-name": "Grupo 1064",
    transform: "translate(-2670.546 7264.647)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_124",
    "data-name": "Elipse 124",
    cx: 13.649,
    cy: 2.57,
    rx: 13.649,
    ry: 2.57,
    transform: "translate(2671.546 -7228.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_321",
    "data-name": "L\\xEDnea 321",
    y2: 14.093,
    transform: "translate(2685.196 -7240.514)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_322",
    "data-name": "L\\xEDnea 322",
    y2: 4.299,
    transform: "translate(2690.159 -7240.514)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7300",
    "data-name": "Trazado 7300",
    d: "M2700.993-7226.415a2.482,2.482,0,0,1,2.481-2.482,2.482,2.482,0,0,1,2.482,2.482",
    transform: "translate(-15.797 -16.226)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_323",
    "data-name": "L\\xEDnea 323",
    y2: 14.093,
    transform: "translate(2685.196 -7261.343)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_324",
    "data-name": "L\\xEDnea 324",
    y2: 4.299,
    transform: "translate(2690.159 -7260.818)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_325",
    "data-name": "L\\xEDnea 325",
    y2: 2.304,
    transform: "translate(2690.159 -7254.296)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7301",
    "data-name": "Trazado 7301",
    d: "M2700.993-7261.165a2.481,2.481,0,0,1,2.481-2.481,2.481,2.481,0,0,1,2.482,2.481",
    transform: "translate(-15.797 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_326",
    "data-name": "L\\xEDnea 326",
    y2: 20.962,
    transform: "translate(2683.068 -7247.383)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_327",
    "data-name": "L\\xEDnea 327",
    y2: 4.299,
    transform: "translate(2678.105 -7247.383)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_328",
    "data-name": "L\\xEDnea 328",
    y2: 3.224,
    transform: "translate(2678.105 -7240.514)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7302",
    "data-name": "Trazado 7302",
    d: "M2692.654-7239.3a2.482,2.482,0,0,0-2.481-2.482,2.482,2.482,0,0,0-2.482,2.482",
    transform: "translate(-9.586 -10.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGush);
export default __webpack_public_path__ + "static/media/gush.5ba87d74.svg";
export { ForwardRef as ReactComponent };